// extracted by mini-css-extract-plugin
module.exports = {"root":"VenuePageStyle_root__cPXB1","btn_booking":"VenuePageStyle_btn_booking__24Q38"};